@if (showPanel()) {
  <div
    class="backdrop"
    [class.fade-out]="!fadeBackdrop()"
    (click)="onBackdropClick()"
    (keydown.escape)="onBackdropClick()"
    role="button"
    tabindex="0"
    aria-label="Close side panel"
  ></div>
  <div
    class="sliding-panel"
    [class.open]="animatePanel()"
    [class.left]="position() === 'left'"
    [class.right]="position() === 'right'"
    [style.width]="width()"
  >
    <div
      class="mobile-swipe-indicator"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <div class="swipe-handle"></div>
    </div>
    <div class="side-sheet-content">
      @if (title()) {
        <div class="side-sheet-header">
          <h2 class="side-sheet-title">{{ title() }}</h2>
        </div>
      }
      <ng-content></ng-content>
    </div>
  </div>
}
